import { observer } from 'mobx-react-lite';
import { EventNotificationsEntityIdProvider } from '../../../event-notifications/event-notifications-entity-id-context';
import {
    EventQueueRowData,
    ScheduledEventQueueRowData,
    UnitQueueRowData,
} from '../../../socket/stream-types';
import { getEventQueueRowDataOrScheduledEventQueueRowData } from '../../utils/get-event-queue-row-data';
import { BaseQueueCell } from '../base-queue-cell';

export const ReportingPartyPhoneNumberCell = observer(
    function ReportingPartyPhoneNumberCell(props: {
        data: EventQueueRowData | ScheduledEventQueueRowData | UnitQueueRowData;
    }) {
        const data = getEventQueueRowDataOrScheduledEventQueueRowData(props.data);
        if (!data?.reportingPartyPhoneNumber) return null;
        const eventNotificationsEntityId =
            'reportingPartyId' in data ? data.reportingPartyId : undefined;
        return (
            <EventNotificationsEntityIdProvider entityId={eventNotificationsEntityId}>
                <BaseQueueCell>{data.reportingPartyPhoneNumber}</BaseQueueCell>
            </EventNotificationsEntityIdProvider>
        );
    }
);
